import { loadAsyncComponent } from 'src/components/AsyncComponent';

export const WebsiteAutomationPage = loadAsyncComponent(
  () => import(/* webpackChunkName: "WebsiteAutomationPage" */ './Container'),
  'page'
);
